<template>
    <v-stepper v-model="step">

        <v-stepper-header>

            <v-stepper-step step="1"
                            editable
                            :complete="step > 1"
                            :edit-icon="$vuetify.icons.complete"></v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="2"
                            editable
                            :complete="step > 2"></v-stepper-step>

        </v-stepper-header>

        <v-stepper-items>

            <v-stepper-content step="1">

                <app-general-section v-model="form.general"></app-general-section>

                <app-tags-section label="Tags"  v-model="form"></app-tags-section>

                <app-device-modal-footer @click="step = 2">Avançar</app-device-modal-footer>

            </v-stepper-content>

            <v-stepper-content step="2">
                <app-address-section v-model="form.address"></app-address-section>

                <app-device-modal-footer @click="submit">Salvar</app-device-modal-footer>

            </v-stepper-content>

        </v-stepper-items>

    </v-stepper>
</template>

<script>
    import AppDeviceModalFooter from './DeviceModalFooter'
    import AppAddressSection from './sections/AddressSection'
    import AppGeneralSection from './sections/GeneralSection'
    import EventBus from '@packages/event-bus'
    import AppTagsSection from '@components/user-modal/components/sections/TagsSection'

    export default {
        components: {
            AppDeviceModalFooter,
            AppAddressSection,
            AppGeneralSection,
            AppTagsSection
        },

        data() {
            return {
                listEstablishment:[],
                deviceTypes: [
                    {id: 'MIKROTIK', label: 'MIKROTIK'}
                ],
                timeoutTypes:[
                    {id: 'MINUTO', label: 'MINUTO'},
                    {id: 'HORA', label: 'HORA'},
                    {id: 'DIA', label: 'DIA'},
                ],
                memoryTypes: [
                    {id: null, label: 'NÃO DEFINIDO'},
                    {id: 256, label: '256 MB'},
                    {id: 512, label: '512 MB'},
                    {id: 1024, label: '1 GB'},
                ],

                step: null,

                form: {
                    address:{},
                    general:{
                        deviceType: 'MIKROTIK',
                        timeoutType : 'HORA',
                    }
                },
            }
        },

        mounted() {
            EventBus.$on('RESET_DEVICE_MODAL', this.reset)
        },

        beforeDestroy() {
            EventBus.$off('RESET_DEVICE_MODAL', this.reset)
        },

        methods: {
            reset() {
                this.step = 1
                this.form = {
                    address:{},
                    general:{
                        deviceType: 'MIKROTIK',
                            timeoutType : 'HORA',
                    }
                }

            },

            async submit() {
                await this.$api.devices.create(this.form)

                EventBus.$emit(`LOAD_DEVICES`)

                this.$emit('close')
            },


        },

    }

</script>

<style lang="scss" scoped>

</style>
